<script lang="ts">
    import { Check, ArrowUpRight } from "@lucide/svelte";
    import { page } from "$app/state";
    import { m } from "$lib/paraglide/messages";
    import { ORTHOHOUSE_URL, showsOrthoHouseLinks } from "$lib/utils/orthohouse";

    const showParentLink = $derived(showsOrthoHouseLinks(page.url.pathname));
</script>
<div class="relative overflow-hidden bg-secondary px-2 sm:px-4 py-2 sm:py-3 shadow-md">
    <!-- Phones: the parent-site link sits on its own line under the partner line.
         md+: three columns so the partner line stays centred and the link sits under the cart column. -->
    <div class="relative z-10 flex flex-col items-center gap-0.5 md:container md:mx-auto md:grid md:grid-cols-[1fr_auto_1fr] md:gap-4 md:px-2 lg:px-4">
      <p class="flex items-center text-xs sm:text-sm font-medium text-white whitespace-nowrap md:col-start-2">
          <Check class="me-1 sm:me-1.5 h-3.5 w-3.5 sm:h-4 sm:w-4 text-white flex-shrink-0" />
        <span>
          {m.banner_plain1()} <span class="font-bold">{m.banner_bold()}</span> {m.banner_plain2()} <enhanced:img
          src="/static/kybun_large_red.png"
          alt="Kybun™ logo"
          class="inline-block mx-0.5 sm:mx-1 align-middle"
          width="55"
          height="17"
        />  {m.banner_suffix()}
        </span>
      </p>
      {#if showParentLink}
        <a
          href={ORTHOHOUSE_URL}
          dir="auto"
          class="inline-flex items-center gap-1 justify-self-end rounded-sm text-[11px] sm:text-xs font-medium text-white/85 underline decoration-white/30 underline-offset-4 transition-colors hover:text-white hover:decoration-white focus-visible:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white md:no-underline md:hover:underline"
        >
          {m.orthohouse_part_of()}
          <span class="sr-only">(orthohouse.com.cy)</span>
          <ArrowUpRight size={14} color="currentColor" class="shrink-0 rtl:-scale-x-100" aria-hidden="true" />
        </a>
      {/if}
    </div>
  </div>
